import React  from 'react';
import './Footer.css';
import { decruptCipherJson } from '../utils/CommonLibrary';

function Protected() {
  
    const menuArr = localStorage.getItem('dashboard') ? localStorage.getItem('dashboard') : '';
    const dashboard = decruptCipherJson(menuArr);
  
    return (
      <>
        <section className='footer'>
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-md-6">
                        <img src="https://storage.googleapis.com/ksabupatest/2024/09/24/qur4n/73nutjmazs.png" style={{height:"42px"}} alt="" />
                    </div>
                    <div className="col-md-6">
                        <h6 className="footer-right">
                            Last active {dashboard.timeActive}
                        </h6>
                    </div>
                </div>
            </div>
        </section>
      </>
    );
  }
  
  export default Protected;